import { useState } from "react"
import { Button } from "./Button"
import { CommandButton } from "./CommandButton"

type PrintMode = "WITH_PICTURE" | "WITHOUT_PICTURE" | "WITH_VALUE"

type CustomPrintHoverProps = {
  onClick?: (withImage: boolean) => void
  onPrint?: (mode: PrintMode) => void
}

export const CustomPrintHover = ({ onClick, onPrint }: CustomPrintHoverProps) => {
  const [hovered, setHovered] = useState(false)

  const mapModeToLegacy = (mode: PrintMode): boolean | null => {
    switch (mode) {
      case "WITH_PICTURE":
        return true
      case "WITHOUT_PICTURE":
        return false
      default:
        return null
    }
  }
  const handlePrint = (mode: PrintMode) => {
    onPrint?.(mode)

    const legacyValue = mapModeToLegacy(mode)
    if (legacyValue !== null) {
      onClick?.(legacyValue)
    }
  }

  return (
    <div
      className="relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <CommandButton actiontype="print" />

      {hovered && (
        <div className="absolute bottom-0 -right-40 w-40 space-y-1">
          <Button onClick={() => handlePrint("WITH_PICTURE")}>
            PRINT WITH PICTURE
          </Button>

          <Button onClick={() => handlePrint("WITHOUT_PICTURE")}>
            PRINT WITHOUT PICTURE
          </Button>

          <Button onClick={() => handlePrint("WITH_VALUE")}>
            PRINT WITH VALUE
          </Button>
        </div>
      )}
    </div>
  )
}
